import {
    MaterialValidationMessages,
    validateMaterialName,
    validateMaterialAvailability,
    normalizeAvailabilityForForm,
    availabilityToPayload
} from '../enums';
import { isValidHttpUrl } from '@features/uploadAsset';
import { t } from '@i18n';

/**
 * Data Transfer Object for updating a material (URLs for files — no base64).
 */
export class UpdateMaterialDTO {
    constructor({
        id,
        name,
        availability,
        path,
        banner,
        allow_download
    }) {
        this._id = id;
        this.name = name?.trim();
        this.availability = normalizeAvailabilityForForm(availability);
        this.path = path;
        this.banner = banner && isValidHttpUrl(banner) ? banner : undefined;
        this.allow_download = allow_download !== false;
    }

    getId() {
        return this._id;
    }

    /**
     * @returns {{valid: boolean, error?: string}}
     */
    validate() {
        if (!this._id) {
            return {
                valid: false,
                error: MaterialValidationMessages.ID_REQUIRED
            };
        }

        const nameValidation = validateMaterialName(this.name);
        if (!nameValidation.valid) {
            return nameValidation;
        }

        const availabilityValidation = validateMaterialAvailability(this.availability);
        if (!availabilityValidation.valid) {
            return availabilityValidation;
        }

        if (!isValidHttpUrl(this.path)) {
            return {
                valid: false,
                error: MaterialValidationMessages.MATERIAL_REQUIRED
            };
        }

        if (this.banner != null && this.banner !== '' && !isValidHttpUrl(this.banner)) {
            return {
                valid: false,
                error: t('contentModals:manageMaterial.errors.invalidBannerUrl')
            };
        }

        return { valid: true };
    }

    /**
     * @returns {Object}
     */
    toPayload() {
        const payload = {
            name: this.name,
            path: this.path,
            availability: availabilityToPayload(this.availability),
            allow_download: this.allow_download
        };

        if (this.banner) {
            payload.banner = this.banner;
        }

        return payload;
    }
}
